import { render, staticRenderFns } from "./goodsTypeList.vue?vue&type=template&id=210f0e52"
import script from "./goodsTypeList.vue?vue&type=script&lang=js"
export * from "./goodsTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports